import { Handset } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import Link from 'next/link';

import { joinSgcmMsSite } from '@/utils/url/join/public';
import { getPhoneUrl } from '@/utils/url/phone';

import { PROMOTION_DEALER_INFO_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const CarBasicInfo: Component = ({
  carDetail,
  handleAddToShortlist,
}) => carDetail?.authorizeDealers && (
  <div className={styles.carBasicContainer}>
    <div className={styles.dealerInfoContainer}>
      <Link
        className={styles.linkDealer}
        href={`${joinSgcmMsSite(`/new-cars/listing/search?dealer_id=${carDetail?.authorizeDealers?.[0]?.id}`)}`}>
        {carDetail?.authorizeDealers?.[0]?.name}
      </Link>
      <div>
        <ul
          className={styles.listDealerInfo}>
          <li
            className={cx(
              styles.containerDealerInfo,
              styles.isPhoneNumber,
            )}>
            <div
              className={styles.containerDealerInfoIcon}>
              <Handset
                size={PROMOTION_DEALER_INFO_ICON_SIZE} />
            </div>
            <ul
              className={styles.listDealerPhoneNumber}>
              {
                carDetail?.authorizeDealers?.[0].hotlines
                  .map(phoneNumber => (
                    <li
                      key={phoneNumber}
                      className={styles.containerDealerPhoneNumber}>
                      <Link
                        className={styles.textDealerPhoneNumber}
                        href={`${getPhoneUrl(phoneNumber)}`}>
                        {`${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4)}`}
                      </Link>
                    </li>
                  ))
              }
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <button
        className={styles.btnAddToShortlist}
        onClick={handleAddToShortlist}>
        Add to shortlist
      </button>
    </div>
  </div>
);
